import DataTable from '@/common/components/data-table/DataTable.tsx';
import {
  getDefaultColumnOrder,
  getDefaultColumnVisibility,
} from '@/common/utils/data-table.utils.ts';
import { getColumns } from '@/features/admin/cron-jobs/columns.tsx';
import { getCronJobsControllerGetCronJobsQueryOptions } from '@/generated/api/cron-jobs.ts';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/admin/general/cron-jobs')({
  component: RouteComponent,
});

function RouteComponent() {
  const cronJobsQuery = useQuery(
    getCronJobsControllerGetCronJobsQueryOptions({
      query: {
        refetchInterval: 5_000,
      },
    }),
  );

  const columns = useMemo(() => getColumns(), []);
  const defaultVisibleColumns = useMemo(
    () => getDefaultColumnVisibility(columns),
    [columns],
  );
  const defaultColumnOrder = useMemo(() => getDefaultColumnOrder(columns), [columns]);

  return (
    <DataTable
      columns={columns}
      columnVisibility={defaultVisibleColumns}
      columnOrder={defaultColumnOrder}
      data={cronJobsQuery.data ?? []}
      density="tight"
      loading={cronJobsQuery.isLoading}
    />
  );
}
